module.exports = __webpack_public_path__ + "eaf8f852c46c4e449346ac457bf80f0d.svg";